import { Box, Text, Flex } from '@chakra-ui/react';
import { redirectToNewPage } from '../../global/helpers/global-helpers';
import { LiaHourglassEndSolid } from "react-icons/lia";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { IoLockOpen } from 'react-icons/io5'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


export default function IdleRoomUnlockedModal() {

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={LiaHourglassEndSolid} color='brand.500' boxSize="1.6em" />
        <Box color='white'>Idle Room unlocked</Box>
      </Flex>}
      noCancelOption={true}
      // handleCloseModal={() => handleCloseModal()}
      showModal={true}
    // maxW='35em'
    >
      <DisplayContent />
    </LaunchdeckModal>
  );
}



function DisplayContent() {

  return (
    <Box w='100%' p='1em 1.8em'>
      <Flex direction='column' alignItems='center' justify='center' w='100%'>
        <Box mb='0.5em'>
          <Box as={IoLockOpen} color='brandDark.500' boxSize="3em" />
        </Box>

        <Flex direction='column' gap='0.25em' w='100%' fontSize='0.9em' mt='1em' fontWeight='400' lineHeight='1.375em'>
          <Text textAlign='center'>Your draft has been left idle for 60 mins</Text>
          <Text textAlign='center'>We've unlocked it to allow other Room Administrators to edit it</Text>
        </Flex>

        <Box mt='3em'>
          <LaunchdeckButton bg='brand.500' color='white' px='2em' w={['100%', 'auto']} fontSize='0.8em' py='0.4em' onClick={() => redirectToNewPage(`/vault`)} label='OK, got it' />
        </Box>
      </Flex>
    </Box>
  )
}
